import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';
import { minutes } from '~/shared/utils/helpers';

interface GetCheckoutArguments extends ShopTypes.CheckoutOptions {
    reference: string | undefined;
}

export default function getCheckout({ reference, ...rest }: GetCheckoutArguments) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop
        .post(getUrl(`/checkout/checkout/${reference}`), {
            json: rest as ShopTypes.CheckoutOptions,
            timeout: minutes(5),
        })
        .json<ShopTypes.CheckoutQueryResult>();
}
